import React from 'react';
import styles from './Message.module.css';

const Message = ({ message, isVertical }) => {
  return (
    <div className={styles.wrapper}>
      <div
        className={styles.photoBlock}
        style={{ padding: isVertical ? '12rem 0' : '25rem 0' }}>
        <img
          src={message?.attachments[0].url}
          alt={'photo'}
          className={styles.photoImg}
        />
      </div>
    </div>
  );
};

export default Message;
